import React from 'react';
import emojisList from '../constant/em.json';

function emojiTranslate(message) {
  const emojis = message ? message.match(/\([^\)]+\)/gi) : '';
  let displayMessage = message || '';
  if (emojis) {
    emojis.map((emoji) => {
      const em = emoji.replace('(', '').replace(')', '');
      const char = emojisList[em];
      if (char) displayMessage = displayMessage.replace(emoji, char);
    });
  }
  const images = displayMessage.match(/\[img src='([^']+)'\]/gi);
  if (images) {
    displayMessage = displayMessage
      .split(/\[img src='([^']+)'\]/gi)
      .map((line) => {
        if (line.substr(0, 4) === 'http') {
          return <img className="emoji" src={line} />;
        }
        return line;
      });
    // displayMessage = displayMessage.replace(/\[img src='([^']+)'\]/gi, '<img src="$1" />');
    // images.map(image => {
    //
    // })
  }
  return displayMessage;
}

export default emojiTranslate;
